// extracted by mini-css-extract-plugin
export default {"index":"articles_index__B9el8","body":"articles_body__D+ylU","toolbar":"articles_toolbar__rTzMz"};